"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUawEnvironmentConfig = exports.parseUawEnvironmentConfigs = exports.decodeSiteCoreJsonString = void 0;
var _he = _interopRequireDefault(require("he"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
const parseUawEnvironmentConfigs = uawConfigString => {
  if (!uawConfigString) {
    return {};
  }
  const result = {};
  const pairs = uawConfigString.split('&');
  pairs.forEach(pair => {
    const [key, value] = pair.split('=');
    const decodedValue = decodeURIComponent(value);
    result[key] = JSON.parse(decodedValue);
  });
  return result;
};
exports.parseUawEnvironmentConfigs = parseUawEnvironmentConfigs;
const decodeSiteCoreJsonString = encodedJson => {
  if (!encodedJson) {
    return {};
  }

  // Step 1: Remove the <p> tags
  const noPTags = encodedJson.replace(/<\/?p>/g, '');

  // Step 2: Decode the HTML entities
  const decodedJson = _he.default.decode(noPTags);
  const convertEmBackToUnderscore = decodedJson.replace(/<\/?em>/g, '_');

  // Step 3: Parse the JSON string
  return JSON.parse(convertEmBackToUnderscore);
};
exports.decodeSiteCoreJsonString = decodeSiteCoreJsonString;
const selectUawEnvironmentConfig = uawEnvConfigs => {
  return uawEnvConfigs[(0, _patternLibraryUtils.getDefaultEnv)()];
};
exports.selectUawEnvironmentConfig = selectUawEnvironmentConfig;